module.exports = __webpack_public_path__ + "img/wealthtop2.a238a04e.png";